export default "__VITE_ASSET__v7TjyZvr__"